import { Component, Vue, Watch } from 'vue-property-decorator';
import check from '@/assets/js/check/check';

@Component({
    components: {

    },
})
export default class Recharge extends Vue {
  private $api: any;
  private amount: string = '';  // 金额
  private canRecharge: boolean = false;   // 充值按钮是否可用
  private isRecharging: boolean = false;  // 是否正在调用充值接口
  private isGettingRechargeKey: boolean = true; // 是否正在获取密钥中
  private rechargeKey: string = '';       // 当前充值接口的密钥
  private userId: string = '';            // 充值用户的ID
  private userInfo: string = '';          // 充值用户的信息
  private rechargeDate: string = '';      // 充值的月份
  private canShowDialog: boolean = false;    // 是否弹出对话框
  private neverShowDialog: boolean = false;  // 是否点了不再提示
  private maxAmount: number = 1000;       // 最大充值金额
  private minAmount: number = 50;        // 最小充值金额


  // life cycle
  private mounted() {
    this.getKey();
    this.showDialog();
  }

  @Watch('amount')
  private onAmountChanged(val: string, oldVal: string) {
    this.canRecharge = false;
    const rule = /^[0-9]+$/;
    // 只能输入数字
    if (!rule.test(val) && val !== '') {
      this.amount = oldVal;
    } else {
      // 如果值不为空
      if (val !== '') {
        const amount = parseInt(val, 10);
        // 如果输入的是 0
        if (amount === 0) {
          this.amount = '';
          // this.$toast('无法充值0元');
        } else if (amount >= this.minAmount) {
          if (amount % 50 !== 0) {
            this.$notify('只能充值50的倍数');
          } else if (amount > this.maxAmount) {
            this.$notify(`无法充值${this.maxAmount}元以上`);
          } else {
            this.canRecharge = true;
          }
        }
      }
    }
  }


  // 点击充值按钮
  private recharge() {
    if (!this.canRecharge) {
      return;
    }
    // console.log(this.amount);
    if (this.amount === '' || this.amount === '0') {
      this.$notify('请填写充值金额');
    } else {
      // 提交充值
      this.rechargeSubmit();
    }
  }

  // 第一次握手，得到充值接口可用的密钥
  private async getKey() {
    this.isGettingRechargeKey = true;
    const result = await this.$api.httpPost('Salary/SupermarketRecharge/GiveKey');
    if (result.Success) {
      // console.log(result.Data);
      // 记录返回的密钥和员工信息
      this.rechargeKey = result.Data.Key;
      this.userId = result.Data.UserBaseInfoId;
      this.userInfo = result.Data.RechargeAccount;
      this.rechargeDate = result.Data.RechargeDate;
      this.isGettingRechargeKey = false;
    } else {
        this.$notify(result.AllMessages);
    }
  }

  // 充值提交
  private async rechargeSubmit() {
    this.isRecharging = true;
    this.$toast.loading({
        duration: 0,       // 持续展示toast
        forbidClick: true, // 禁用背景点击
        loadingType: 'spinner',
        message: '正在充值...',
    });
    const params = {
      UserBaseInfoId : this.userId,
      Key: this.rechargeKey,
      RechargeAmount: parseFloat(this.amount),
    };
    const result = await this.$api.httpPost('Salary/SupermarketRecharge/WeChatSupermarketRechargeDetail', params);
    if (result.Success) {
      // 充值成功
      this.$dialog.alert({
        title: '充值成功',
        message: '已充值' + this.amount + '元',
      }).then(() => {
        // on close
        this.cancel();
      });
    } else {
        // 改成弹窗
        this.$notify(result.AllMessages);
        this.isRecharging = false;
        this.getKey();  // 重新获取key,用于下一次支付
    }
    this.$toast.clear();
  }

  // 弹出对话框 
  private showDialog() {
    // 先检查本地是否已经有不再提示的缓存
    const status = localStorage.getItem('neverShowRechargeDialog');
    if (!check.checkNull(status)) {
      this.canShowDialog = true;
    }
  }

  // 对话框确认
  private onConfirm() {
    // 如果点了 下次不再提示
    if (this.neverShowDialog) {
      localStorage.setItem('neverShowRechargeDialog', 'ture');
    }
  }

  // 取消充值
  private cancel() {
    this.$router.go(-1);
    // this.$router.push('/recharge-list');
  }

}
